// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ii-0";